import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result, User } from "../../../../interfaces";
import { Create } from "../../../user";
import { Adapter } from "../../../../shared/adapter";
import { UsersAdapter } from "../../../../adapter/users-adapter";

export const FETCH_CREATE_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_CREATE_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_CREATE_USERS_FAILURE = 'FETCH_USERS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchCreateUsersRequest = () => {
    return {
        type: FETCH_CREATE_USERS_REQUEST,
    };
};

const fetchCreateUsersSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_CREATE_USERS_SUCCESS,
        payload: data
    };
};

const fetchCreateUsersFailure = (error: any) => {
    return {
        type: FETCH_CREATE_USERS_FAILURE,
        payload: error,
    };
};

export const clear = ()=>{
    return {
        type: "CLEAR_DATA",
    };  
}

export const create = (user:User) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchCreateUsersRequest());
        try {
            const response = await Create(user);
            dispatch(fetchCreateUsersSuccess(
                Adapter.from(response.data).to((value) => new UsersAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchCreateUsersFailure(error.message));
        }
    };
};